/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * A star icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {import('./sizes').IconSize} [props.size] The icon size.
 */
export default function StarIcon({ size = 'small', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'sub',
      }}
      viewBox="0 0 20 20"
      fill="none"
      {...rest}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.785 15.644l-5.738 3.017 1.096-6.39L.5 7.746l6.416-.932L9.785 1l2.87 5.814 6.415.932-4.643 4.525 1.096 6.39-5.738-3.017z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
